import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=2f53e4f4&scoped=true&"
import script from "./Messages.vue?vue&type=script&lang=js&"
export * from "./Messages.vue?vue&type=script&lang=js&"
import style0 from "./Messages.vue?vue&type=style&index=0&id=2f53e4f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f53e4f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f53e4f4')) {
      api.createRecord('2f53e4f4', component.options)
    } else {
      api.reload('2f53e4f4', component.options)
    }
    module.hot.accept("./Messages.vue?vue&type=template&id=2f53e4f4&scoped=true&", function () {
      api.rerender('2f53e4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Messages.vue"
export default component.exports